import React from "react";

interface ProductDetailCardProps {
  title: string;
  content: string;
  type: "text" | "editabletext" | "dropdown" | "checkbox" | "radio" | "textarea";
  options?: string[]; // Für Dropdown, Checkbox und Radio erforderlich
}

const ProductDetailCard: React.FC<ProductDetailCardProps> = ({ title, content, type, options = [] }) => {
  const renderContent = () => {
    switch (type) {
      case "text":
        return <div className="detail-text">{content}</div>;

      case "editabletext":
        return (
          <div
            contentEditable={true}
            className="detail-input"
            style={{ border: "1px solid #ccc", padding: "5px", borderRadius: "4px" }}
          >
            {content}
          </div>
        );

      case "dropdown":
        return (
          <select className="detail-select" defaultValue={content}>
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        );

      case "checkbox":
        return (
          <div className="detail-checkbox-group">
            {options.map((option, index) => (
              <label key={index} className="checkbox-label">
                <input type="checkbox" defaultChecked={option === content} />
                {option}
              </label>
            ))}
          </div>
        );

      case "radio":
        return (
          <div className="detail-radio-group">
            {options.map((option, index) => (
              <label key={index} className="radio-label">
                <input type="radio" name={title} defaultChecked={option === content} />
                {option}
              </label>
            ))}
          </div>
        );

      case "textarea":
        return <textarea className="detail-textarea" defaultValue={content} />;

      default:
        return null;
    }
  };

  return (
    <div className="product-detail-card">
      <div className="detail-title">{title}</div>
      <div className="detail-content">{renderContent()}</div>
    </div>
  );
};

export default ProductDetailCard;
